import { useEffect, useState, createContext, useContext } from "react";
import { isAutheticated } from "../components/auth/authhelper";
import axios from "axios";
import { API } from "../API";
import Api from "../Api/Api";
import { toastSuccess } from "../utilis/toast";
import { toast } from "react-toastify";

export const AppContext = createContext(); // Define the AppContext

export const AppProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [banners, setBanners] = useState([]);
    const [cartData, setCartData] = useState({
        products: [],
        total_price: 0,
        shipping_price: 0, // Example shipping cost
        total_quantity: 0,
        currency_symbol: "$",
    });
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [headerLogo, setHeaderLogo] = useState("");

    const { token } = isAutheticated();

    // // Load cart from localStorage on mount
    // useEffect(() => {
    //     const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    //     setCartData(storedCart);
    //     calculateTotals(storedCart);
    // }, []);
    // Load cart from localStorage when component mounts
    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem("cart")) || {
            products: [],
            total_price: 0,
            shipping_price: 0,
            total_quantity: 0,
            currency_symbol: "$",
        };
        setCartData(storedCart);
    }, []);

    // Save cart to localStorage whenever it updates
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cartData));
    }, [cartData]);


    //Fetch logo
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await axios.get(`${API}/api/config/`);
                if (response.data.result[0]?.logo[0]?.Headerlogo) {
                    setHeaderLogo(response.data.result[0]?.logo[0]?.Headerlogo);
                }
            } catch (error) {
                console.error("Failed to fetch the Admin logo:", error);
            }
        };
        fetchLogo();
    }, []);
    // Fetch user data

    useEffect(() => {
        const getUser = async () => {
            if (!token) {
                setUserData(false);
                return;
            }
            try {
                const response = await axios.get(`${API}/api/client`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUserData(response.data?.data || null);
            } catch (err) {
                console.error("Failed to fetch user data:", err);
                setUserData(false);
            }
        };
        getUser();
    }, [token]);

    // Fetch banners
    useEffect(() => {
        const getBanners = async () => {
            try {
                const response = await axios.get(`${API}/api/banner/Webbanner`, {
                    headers: { "Content-Type": "application/json" },
                });
                setBanners(response.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch banners:", err);
            }
        };
        getBanners();
    }, []);

    // Check subscription
    useEffect(() => {
        const checkSubscription = async () => {
            if (!token) {
                setSubscription(false);
                return;
            }
            try {
                const response = await axios.get(`${API}/api/client/username/checkSubscription`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubscription(response.data?.data || null);
            } catch (err) {
                console.error("Failed to check subscription:", err);
                setSubscription(false);
            }
        };
        checkSubscription();
    }, [token]);
    const homeBanners = banners.filter((banner) => banner?.category === "Home");
    const videosBanners = banners.filter((banner) => banner?.category === "Videos");
    const shopBanners = banners.filter((banner) => banner?.category === "Shop");
    // Fetch cart data
    // useEffect(() => {
    //     const getCart = async () => {
    //         try {
    //             const data = await Api.getCart();
    //             console.log('Cart data:', data);
    //             // setCartData(data.products || []); // Update cartData to only store the `products` array
    //             setCartData({
    //                 products: data.products || [],
    //                 total_price: data.cart_total_price || 0,
    //                 shipping_price: data.shipping_price || 0,
    //                 total_quantity: data.products?.reduce((sum, product) => sum + product.quantity, 0) || 0,
    //             });
    //             setTotalQuantity(
    //                 data.products?.reduce((sum, product) => sum + product.quantity, 0) || 0
    //             );
    //             setTotalAmount(data.cart_total_price || 0); // Use `cart_total_price` for the total amount
    //         } catch (err) {
    //             console.error("Failed to fetch cart data:", err);
    //         }
    //     };
    //     getCart();
    // }, []);



    // // Calculate total quantity and amount
    // const calculateTotals = (cart) => {
    //     const totalQty = cart.reduce((sum, product) => sum + product.quantity, 0) || 0;
    //     const totalAmt = cart.reduce(
    //         (sum, product) => sum + product.quantity * product.pid?.price,
    //         0
    //     ) || 0;
    //     setTotalQuantity(totalQty);
    //     setTotalAmount(totalAmt);
    // };


    // // Increase item quantity
    // const increaseItemQuantity = async (productId) => {
    //     try {
    //         const updatedCart = await Api.updateCart(productId, "increase");
    //         setCartData(updatedCart.products || []);
    //         setTotalAmount(updatedCart.cart_total_price || 0);
    //     } catch (err) {
    //         console.error("Failed to increase item quantity:", err);
    //     }
    // };

    // // Decrease item quantity
    // const decreaseItemQuantity = async (productId) => {
    //     try {
    //         const updatedCart = await Api.updateCart(productId, "decrease");
    //         setCartData(updatedCart.products || []);
    //         setTotalAmount(updatedCart.cart_total_price || 0);
    //     } catch (err) {
    //         console.error("Failed to decrease item quantity:", err);
    //     }
    // };

    // // Remove item from cart
    // const removeItem = async (productId) => {
    //     try {
    //         const updatedCart = await Api.removeCartItem(productId);
    //         setCartData(updatedCart.products || []);
    //         setTotalAmount(updatedCart.cart_total_price || 0);
    //     } catch (err) {
    //         console.error("Failed to remove item:", err);
    //     }
    // };
    // Calculate total quantity and total amount
    // const calculateTotals = (cart) => {
    //     const totalQty = cart.reduce((sum, product) => sum + product.quantity, 0) || 0;
    //     const totalAmt = cart.reduce((sum, product) => sum + product.quantity * product.price, 0) || 0;
    //     setTotalQuantity(totalQty);
    //     setTotalAmount(totalAmt);
    // };
    // 🛒 Add to Cart
    const addToCart = (product) => {
        const selectedProduct = {
            id: product?.product?._id,
            title: product?.product?.title,
            price: parseFloat(product?.product?.total_price.replace(/[^0-9.]/g, "")), // Extract numeric price
            quantity: 1,
            image: product?.product?.image
        };

        let updatedCart = { ...cartData };
        const existingItem = updatedCart.products.find((item) => item.id === selectedProduct.id);

        if (existingItem) {
            updatedCart.products = updatedCart.products.map((item) =>
                item.id === selectedProduct.id ? { ...item, quantity: item.quantity + 1 } : item
            );
        } else {
            updatedCart.products = [...updatedCart.products, selectedProduct];
        }

        // Recalculate totals
        updatedCart.total_quantity = updatedCart.products.reduce((sum, item) => sum + item.quantity, 0);
        updatedCart.total_price = updatedCart.products.reduce((sum, item) => sum + item.quantity * item.price, 0);

        // Ensure currency symbol persists
        updatedCart.currency_symbol = product?.product?.total_price.match(/[^\d.,]/)?.[0] || updatedCart.currency_symbol || "$";

        // Save updated cart
        setCartData(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));

        toastSuccess(`Product Added Successfully (${updatedCart.currency_symbol}${selectedProduct.price})`);
    };


    // ➕ Increase Quantity
    const increaseItemQuantity = (productId) => {
        const updatedProducts = cartData.products.map((item) =>
            item.id === productId ? { ...item, quantity: item.quantity + 1 } : item
        );
        updateCart(updatedProducts);
    };

    // ➖ Decrease Quantity
    const decreaseItemQuantity = (productId) => {
        const updatedProducts = cartData.products.map((item) =>
            item.id === productId ? { ...item, quantity: item.quantity > 1 ? item.quantity - 1 : 1 } : item
        );
        updateCart(updatedProducts);
    };

    // ❌ Remove Item
    const removeItem = (productId) => {
        const updatedProducts = cartData.products.filter((item) => item.id !== productId);
        updateCart(updatedProducts);
        toast.info("Product Removed from Cart!");
    };

    // 📊 Calculate Totals
    const calculateTotals = (products) => {
        const totalQuantity = products.reduce((sum, item) => sum + item.quantity, 0);
        const totalPrice = products.reduce((sum, item) => sum + item.quantity * item.price, 0);
        return { total_price: totalPrice, total_quantity: totalQuantity };
    };

    // 🔄 Update Cart & Save to LocalStorage
    const updateCart = (updatedProducts) => {
        const { total_price, total_quantity } = calculateTotals(updatedProducts);
        setCartData({
            ...cartData,
            products: updatedProducts,
            total_price,
            total_quantity,
        });
    };

    return (
        <AppContext.Provider
            value={{
                headerLogo,
                userData,
                subscription,
                banners,
                homeBanners,
                videosBanners,
                shopBanners,
                cartData,
                addToCart,
                totalQuantity,
                totalAmount,
                increaseItemQuantity,
                decreaseItemQuantity,
                removeItem,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};
export const useAppContext = () => {
    return useContext(AppContext);
};
